import { type RequiredFileModel, type Stored, type UUID } from "@overmap-ai/common"
import { BaseOfflineFileModelApiService } from "@overmap-ai/core"
import { useCallback } from "react"

import { useFetchFileFromFileModel } from "../../hooks/utils"
import { AppSDK } from "../../sdk"
import type { RootState } from "../../store"
import { genericMemo } from "../../utils/optimization"
import { FileCard } from "./FileCard"

interface FileAttachmentCardProps<TAttachment extends UUID<RequiredFileModel>> {
	attachment: Stored<TAttachment>
	onDelete?: (attachment: Stored<TAttachment>) => void
	service: BaseOfflineFileModelApiService<string, TAttachment, RootState, AppSDK>
}

export const FileAttachmentCard = genericMemo(function <TAttachment extends UUID<RequiredFileModel>>(
	props: FileAttachmentCardProps<TAttachment>,
) {
	const { attachment, onDelete, service } = props

	const [fetchedFile, failed] = useFetchFileFromFileModel(attachment, service)

	const handleDeleteFile = useCallback(() => {
		onDelete?.(attachment)
	}, [attachment, onDelete])

	return (
		<FileCard
			size="sm"
			file={fetchedFile}
			onDelete={handleDeleteFile}
			error={failed ? attachment.file_name : undefined}
		/>
	)
})
